module.exports = __webpack_public_path__ + "static/media/warning.8b17b8f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MobileApp/warning.svg
// module id = 981
// module chunks = 0